"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardCommon_en_us = void 0;
function dashboardCommon_en_us() {
    return {
        "dashboard.widgets.count.choices.users": "Customers",
        "dashboard.widgets.count.choices.cmspages": "CMS-Pages",
        "dashboard.widgets.count.choices.products": "Products",
        "dashboard.widgets.count.choices.checkin.users": "Checkin-Users",
        "dashboard.widgets.count.choices.visits_lastweek": "Visits last week",
        "dashboard.widgets.count.choices.visits_lastmonth": "Visits last month",
        "dashboard.widgets.count.choices.unverified_users": "Unverified Users",
        "dashboard.widgets.count.choices.workflows": "Workflows",
        "dashboard.widgets.count.choices.orders": "Orders",
        "dashboard.widgets.count.choices.open_orders": "Open Orders",
        "dashboard.widgets.event.date": "Date",
        "dashboard.widgets.event.title": "Title",
        "dashboard.widgets.event.numberentries": "How many entries should be displayed?",
        "dashboard.widgets.event.appointmentcounter": "${count} more appointments available",
        "dashboard.widgets.event.appointmentcountersingular": "${count} more appointment available",
        "dashboard.widgets.event.noappointmentsavailable": "No appointments available",
        "dashboard.widgets.lastnewuserregistrations.name": "Name",
        "dashboard.widgets.lastnewuserregistrations.createdat": "Creation Date",
        "dashboard.widgets.lastnewuserregistrations.usercounter": "${count} total users available",
        "dashboard.widgets.lastnewuserregistrations.nousersavailable": "No users available",
        "dashboard.widgets.externalcount.noconfig": "No configuration has been created yet.",
        "dashboard.widgets.calendar.whichcalendar": "Which calendar should be displayed?",
        "dashboard.widgets.calendar.timegridweek": "Week",
        "dashboard.widgets.calendar.daygridmonth": "Month",
        "dashboard.widgets.dateformat.short": "Short: M/d/yy, h:mm a",
        "dashboard.widgets.dateformat.medium": "Medium: MMM d, y, h:mm:ss a",
        "dashboard.widgets.dateformat.long": "Long: MMMM d, y, h:mm:ss a z",
        "dashboard.widgets.dateformat.shortdate": "Short Date: M/d/yy",
        "dashboard.widgets.dateformat.mediumdate": "Medium Date: MMM d, y",
        "dashboard.widgets.dateformat.longdate": "Long Date: MMMM d, y",
        "dashboard.widgets.dateformat.fulldate": "Full Date: EEEE, MMMM d, y",
        "dashboard.widgets.dateformat.shorttime": "Short Time: h:mm a",
        "dashboard.widgets.dateformat.mediumtime": "Medium Time: h:mm:ss a",
        "dashboard.widgets.dateformat.longtime": "Long Time: h:mm:ss a z",
        "dashboard.widgets.dateformat.fulltime": "Full Time: h:mm:ss a zzzz",
        "dashboard.widgets.dateformat.currency": "Currency",
        "dashboard.widgets.dateformat.--": "--",
        "dashboard.widgets.image.clickaction.link": "Link",
        "dashboard.widgets.image.clickaction.openindialog": "Open in Dialog",
        "dashboard.widgets.contextcontainer.notemplatedefined": "No content template defined. Edit the widget and specify how the data should be displayed.",
        "dashboard.widgets.contextcontainer.nomodel": "No data could be loaded. Possible reasons:",
        "dashboard.widgets.contextcontainer.nomodel.nostoreloaded": "No store data could be loaded",
        "dashboard.widgets.contextcontainer.nomodel.nodatasource": "No data source selected",
        "dashboard.widgets.contextcontainer.nomodel.queryparameter": "Query Parameter is missing or wrong.",
        "dashboard.widgets.contextcontainer.nomodel.routeparameter": "Route Parameter is missing or wrong.",
        "dashboard.widgets.contextcontainer.nomodel.fixedid": "Fixed ID is missing or wrong.",
        "dashboard.widgets.contextcontainer.nomodel.contextproperty": "Context Property is missing or wrong.",
        "dashboard.widgets.contextcontainer.nomodel.nodataselector": "No data selector choosen.",
        "dashboard.widgets.contextcontainer.dataselector.queryparameter": "Query Parameter",
        "dashboard.widgets.contextcontainer.dataselector.routeparameter": "Route Parameter",
        "dashboard.widgets.contextcontainer.dataselector.fixedid": "Fixed ID",
        "dashboard.widgets.contextcontainer.dataselector.contextproperty": "Context Property"
    };
}
exports.dashboardCommon_en_us = dashboardCommon_en_us;
